import axios from '@/http/axios'

export function loginUser (credentials) {
  if (!credentials.super_admin) return axios({
    url: 'v1/admin/login',
    data: {
      phone_number: credentials.phoneNumber,
      code: credentials.otpCode
    },
    method: 'post'
  })

  else return axios({
    url: `v1/admin/login?phone_number=${credentials.phoneNumber}&code=${credentials.otpCode}`,
    data: {
      super_admin: credentials.super_admin,
      phone_number: credentials.phoneNumber,
      token: credentials.token
    },
    method: 'post'
  })

}

export function sendOTPCode (phoneNumber) {
  return axios({
    url: `v1/admin/send-otp?phone_number=${phoneNumber}`,
    // data: {
    //   phone_number: phoneNumber
    // },
    method: 'post'
  })
}

export function resendOTPCode (phoneNumber, voice) {
  return axios({
    url: `v1/admin/send-otp?phone_number=${phoneNumber}`,
    data: {
      phone_number: phoneNumber,
      voice
    },
    method: 'post'
  })
}

export function logoutUser () {
  return axios({
    url: 'v1/logout',
    method: 'post'
  })
}
